var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"bv-example-row"},[_c('b-card',[_c('b-list-group',_vm._l((_vm.data),function(value,key){return _c('b-list-group-item',{key:key},[_vm._v(_vm._s(key)+": "+_vm._s(value))])}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }